/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ImageStructure = {
  imageRef?: string;
  imageBinary?: Array<string>;
  imageContent?: ImageStructure.imageContent;
};

export namespace ImageStructure {
  export enum imageContent {
    MAP = 'MAP',
    GRAPHIC = 'GRAPHIC',
    LOGO = 'LOGO',
  }
}
